import * as PropTypes from 'prop-types';
import {connect} from 'react-redux';
import FieldContainerPropType from '../../../propTypes/FieldContainer.proptype';
import updateShouldStorePaymentDetailsConsent from '../../../v2/actions/paymentActions/updateShouldStorePaymentDetailsConsent';
import InputField from '../../../v2/form/InputField';
import getOptionalPaymentDetailsConsentTranslationKey from '../../../v2/selectors/PaymentOptionSelectors/getOptionalPaymentDetailsConsentTranslationKey';
import getShouldStorePaymentDetails from '../../../v2/selectors/PaymentOptionSelectors/getShouldStorePaymentDetails';

export function StorePaymentOptionConsent(props) {
  const handleChange = () => {
    props.updateShouldStorePaymentDetailsConsent(props.paymentMethodType);
  };
  
  return (
    <div data-test="StorePaymentOptionConsent">
      <InputField
        definedField={{
          type: 'checkbox',
          label: props.optionalPaymentDetailsConsentTranslationKey,
          value: true,
          name: 'StorePaymentOptionConsent',
        }}
        fieldContainer={props.fieldContainer}
        handleChange={handleChange}
        value={props.shouldStorePaymentDetails}
      />
    </div>
  );
}

StorePaymentOptionConsent.propTypes = {
  optionalPaymentDetailsConsentTranslationKey: PropTypes.string,
  fieldContainer: PropTypes.shape(FieldContainerPropType).isRequired,
  shouldStorePaymentDetails: PropTypes.bool.isRequired,
  paymentMethodType: PropTypes.string.isRequired,
  
  // Actions
  updateShouldStorePaymentDetailsConsent: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  shouldStorePaymentDetails: !!getShouldStorePaymentDetails(ownProps.paymentMethodType)(state),
  optionalPaymentDetailsConsentTranslationKey: getOptionalPaymentDetailsConsentTranslationKey(ownProps.paymentMethodType)(state),
});

export default connect(mapStateToProps, {updateShouldStorePaymentDetailsConsent})(StorePaymentOptionConsent);
